import { BaseRepository } from '@ats/repositories';
import type {
  MeetingRoomAttendeeDTO,
  MeetingRoomDTO,
} from 'server/model/meeting.room.dto';
import { MeetingRoomAttendeeInfoDTO } from 'server/model/meeting.room.dto';

/**
 * 화상면접 레포지토리
 * 로컬호스트의 서버에 API 호출을 하기 때문에 POST 호출임에도 쿼리스트링으로 API 호출과 정적파일 렌더링을 구분할 수 있게함.
 */

export class InterviewRepository extends BaseRepository {
  constructor(baseUrl: string) {
    super(baseUrl);
  }

  // 면접관 인터뷰 생성
  public async joinManagerInterview({
    name,
    certificationCode,
    valuerSn,
  }: MeetingRoomDTO) {
    const { data: response } = await super.post<MeetingRoomAttendeeDTO>(
      `/interview/manager/join`,
      {
        name,
        certificationCode,
        valuerSn,
      },
    );

    console.log(response);

    return response;
  }

  // 인터뷰 생성
  public async joinInterview({
    name,
    certificationCode,
    valuerSn,
  }: MeetingRoomDTO) {
    console.log('지원자 인터뷰 생성...');
    const { data: response } = await super.post<MeetingRoomAttendeeDTO>(
      `/interview/attendee/join`,
      {
        name,
        certificationCode,
        valuerSn,
      },
    );

    console.log(response);

    return response;
  }

  // 인터뷰 캐시 삭제
  public async deleteInterviewCache({
    certificationCode,
  }: Pick<MeetingRoomDTO, 'certificationCode'>) {
    const { data: response } = await super.delete<MeetingRoomAttendeeDTO>(
      `/interview/delete-cache?certificationCode=${encodeURIComponent(
        certificationCode,
      )}`,
      {},
    );

    return response;
  }

  // 면접 종료
  public async endInterview({
    certificationCode,
  }: Pick<MeetingRoomDTO, 'certificationCode'>) {
    const { data: response } = await super.delete<{ message: string }>(
      `/interview/end?certificationCode=${encodeURIComponent(
        certificationCode,
      )}`,
      {},
    );

    return response;
  }

  // 응시자 재입장 / 나가기
  public async leaveAttendee({
    certificationCode,
    valuerSn,
  }: Pick<MeetingRoomDTO, 'certificationCode' | 'valuerSn'>) {
    const { data: response } = await super.delete<{ message: string }>(
      `/interview/attendee/end?certificationCode=${encodeURIComponent(
        certificationCode,
      )}&valuerSn=${valuerSn}`,
      {},
    );

    return response;
  }

  // 면접관 나가기 / 재입장
  public async leaveManager({
    certificationCode,
    valuerSn,
  }: Pick<MeetingRoomDTO, 'certificationCode' | 'valuerSn'>) {
    const { data: response } = await super.delete<{ message: string }>(
      `/interview/manager/end?certificationCode=${encodeURIComponent(
        certificationCode,
      )}&valuerSn=${valuerSn}`,
      {},
    );

    return response;
  }

  // 채팅방 생성 요청
  public async postCreateChannelIfAbsent({ channelId }: { channelId: string }) {
    const { data: response } = await super.post<{ invitationCode: string }>(
      `/chat/channel`,
      {
        channelId,
      },
    );
    return response;
  }

  // 구글밋 링크 조회
  public async postGoogleMeetLink({ channelId }: { channelId: string }) {
    const { data: response } = await super.post<{ googleMeet: string }>(
      `/chat/google-meet`,
      {
        channelId,
      },
    );
    return response;
  }

  // 화상면접 참석자 조회
  public async getAttendeesDetail({
    certificationCode,
  }: {
    certificationCode: string;
  }) {
    const { data: response } = await super.get<MeetingRoomAttendeeInfoDTO>(
      `/interview/attendees/detail?certificationCode=${certificationCode}`,
    );
    return response;
  }
}
